/**
 * Reusable tooltip text generators
 */

/**
 * Get the percentile latency tooltip text for KPI card total
 * Used in AppSummaryCard (Latency KPI card bottom/total value)
 */
export const getPercentileLatencyTooltip = () => {
  return "P95 latency over entire time range";
};

/**
 * Get the percentile latency chart tooltip text
 * Used in LatencyAnalysisSection (Percentile Latency chart header)
 */
export const getPercentileLatencyChartTooltip = () => {
  return "Percentile latency in last 1 hour (for 24 hrs time) or last 1 day (for all other times)";
};

/**
 * Get the latency histogram tooltip text
 */
export const getLatencyHistogramTooltip = () => {
  return "Latency duration (in seconds) with number of traces";
};
